<template>
  <div
    id="contents"
    class="coupon contents"
  >
    <navigation-tab :tabs="tabs"></navigation-tab>
    <router-view></router-view>
  </div>
</template>

<script>
import NavigationTab from '@/views/base/NavigationTab'

import { mapActions, mapGetters } from 'vuex'
import mixin from '@/utils/mixin'

export default {
  mixins: [mixin],
  name: 'Coupon',
  components: {
    NavigationTab
  },
  data() {
    return {
      tabs: [{
        name: '사용 가능',
        url: '/coupon/usable'
      },
      {
        name: '사용 불가능',
        url: '/coupon/unusable'
      }]
    }
  },
}
</script>

<style lang="scss">
.coupon {
  .msgHeader {
    text-align: left;
  }
}
</style>
